<div class="min-h-screen flex flex-col">
  <app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>
  <div
    class="flex-1 bg-gradient-to-br from-green-50 via-emerald-100 to-teal-100 flex items-center justify-center p-4 md:p-6">
    <div class="max-w-2xl w-full mx-auto">

      <!-- Main success card -->
      <div
        class="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/40 overflow-hidden transition-all duration-300 transform hover:scale-[1.02]">
        <!-- Decorative top bar -->
        <div class="h-2 bg-gradient-to-r from-green-400 via-emerald-500 to-teal-500"></div>
        <div class="p-4 sm:p-6 md:p-8 text-center">
          <!-- Animated success icon -->
          <div class="flex justify-center mb-6">
            <div
              class="w-24 h-24 bg-gradient-to-br from-green-400 to-emerald-600 rounded-full flex items-center justify-center shadow-lg animate-bounce">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <!-- Success heading -->
          <h6
            class="text-1xl sm:text-3xl md:text-3xl font-extrabold bg-gradient-to-r from-gray-800 to-gray-900 bg-clip-text text-transparent mb-4">
            Your Order has been placed Successfully!
          </h6>

          <!-- Optional supportive message -->
          <p class="text-gray-600 text-base sm:text-lg mb-8 max-w-md mx-auto">
            Thank you for your purchase. A confirmation email has been sent to your registered email address.
          </p>

          <!-- Action buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button (click)="download()"
              class="group relative inline-flex items-center justify-center px-8 py-3 text-base font-semibold text-white bg-indigo-600 rounded-xl shadow-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 active:scale-95">
              <!-- Icon -->
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Order History
            </button>
          </div>
        </div>
      </div>

      <!-- Extra trust badge -->
      <div class="mt-6 text-center text-white/70 text-xs flex justify-center gap-4">
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-green-300 rounded-full"></span> Secure
          Payment</span>
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-blue-300 rounded-full"></span> 30-Day
          Guarantee</span>
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-purple-300 rounded-full"></span> Free
          Support</span>
      </div>
    </div>
  </div>
</div>